import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-body">
        © Carrankings created with ❤️ by Syed Farajuddin
        <br/>
        <br/>
        All images are the property of their respective owners.
        <br/>
        <br/>
        Logo images from Carlogos.org, Animated GIFs from LottieFiles.com
      </div>
    </div>
  );
};

export default Footer;
